import { useState } from 'react';
import {
  Container,
  Header,
  Box,
  Button,
  Form,
  FormField,
  Input,
  SpaceBetween,
  Link,
  Alert,
  Grid,
} from '@cloudscape-design/components';
import { ViewLayout } from '../../../../components/ViewLayout';

export default function SMSConsentDetailsPage() {
  return (
    <ViewLayout
      breadcrumbs={[
        { text: 'Consent', href: '' },
        { text: 'SMS', href: '/consent/sms' },
        { text: 'Details', href: '' },
      ]}
      navigationHide
      header={
        <Header
          description="Consent Details for SMS Messaging from Real Time Feedback"
          variant="h1"
        >
          SMS Consent Details
        </Header>
      }
    >
      <Grid
        gridDefinition={[
          {
            colspan: {
              default: 12,
              l: 8,
              s: 6,
            },
          },
        ]}
      >
        <Container header={<Header variant="h2">Consent Details for SMS Messaging</Header>}>
          <SpaceBetween size="l">
            <Box variant="p">
              <strong>What You’re Agreeing To:</strong>
              <br />
              By opting in, you consent to receive SMS messages from Real Time Feedback. These
              messages may include promotional content, marketing updates, employment status
              notifications, and other related information.
            </Box>
            <Box variant="p">
              <strong>Message Frequency:</strong>
              <br />
              You can expect to receive messages periodically. The frequency may vary based on your
              activity and promotional events.
            </Box>
            <Box variant="p">
              <strong>Message and Data Rates:</strong>
              <br />
              Standard message and data rates may apply. Please consult your mobile service provider
              for further details regarding your messaging plan.
            </Box>
            <Box variant="p">
              <strong>Opt-Out Instructions:</strong>
              <br />
              You may opt out of receiving these messages at any time. To do so, simply reply with
              “STOP” to any SMS message you receive from us or use the opt-out option provided in
              our messages.
            </Box>
            <Box variant="p">
              <strong>Privacy and Data Usage:</strong>
              <br />
              Your privacy is important to us. For more details on how we use and protect your
              personal information, please review our{' '}
              <Link href="/privacy" target="_blank">
                Privacy Policy
              </Link>
              .
            </Box>
            <Box variant="p">
              <strong>Need Help?</strong>
              <br />
              If you have any questions about our SMS messaging or need assistance with your consent
              preferences, please contact us at{' '}
              <Link href="mailto:support@aiescape.io">support@aiescape.io</Link>.
            </Box>
          </SpaceBetween>
        </Container>
      </Grid>
    </ViewLayout>
  );
}
